import React, { useContext } from 'react';
import './i18n';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import Header from './components/Header';
import Footer from './components/Footer'; // ← IMPORTADO
import Home from './pages/Home';
import DonoDaCarga from './pages/DonoDaCarga';
import Motorista from './pages/Motorista';
import Cidades from './pages/Cidades';
import Carreiras from './pages/Carreiras';
import SobreCargaFacil from './pages/SobreCargaFacil';
import Parceiros from './pages/Parceiros';
{/*import AppNoNavegador from './pages/AppNoNavegador'; */}
import AppNoNavegadorMotorista from './pages/AppNoNavegadorMotorista';
import MapaPage from './pages/MapaPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import PreAppNoNavegador from './pages/PreAppNoNavegador';
import PreAppNoNavegadorMotorista from './pages/PreAppNoNavegadorMotorista';
import DownloadApp from './pages/DownloadApp';
import DownloadAppMotorista from './pages/DownloadAppMotorista';
import PerfilDonoCarga from './pages/PerfilDonoCarga';
import PerfilMotorista from './pages/PerfilMotorista';
import RegisterSuccess from './pages/RegisterSuccess';

import { AuthProvider, AuthContext } from './contexts/AuthContext';

// Layout com HEADER (sem footer) – mantido por compatibilidade, mas não será usado
const LayoutWithHeader = ({ children }) => (
  <>
    <Header />
    <main className="main-content">{children}</main>
  </>
);

LayoutWithHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

// NOVO LAYOUT com HEADER + FOOTER
const LayoutWithHeaderAndFooter = ({ children }) => (
  <>
    <Header />
    <main className="main-content">{children}</main>
    <Footer />
  </>
);

LayoutWithHeaderAndFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

// Componente de rota protegida
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <div>Carregando...</div>;

  if (!isAuthenticated) {
    return <Navigate to="/cliente/login" state={{ from: location }} replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="app-container">
          <Routes>
            {/* Páginas SEM layout (pré-app, app no navegador, download, sucesso) */}
            <Route path="/pre-app-no-navegador" element={<PreAppNoNavegador />} />
            <Route path="/pre-app-no-navegador-motorista" element={<PreAppNoNavegadorMotorista />} />
            <Route path="/app-no-navegador-motorista" element={<AppNoNavegadorMotorista />} />
            <Route path="/baixar-app" element={<DownloadApp />} />
            <Route path="/baixar-app-motorista" element={<DownloadAppMotorista />} />
            <Route path="/register-success" element={<RegisterSuccess />} />

            {/* Páginas de perfil protegidas (sem Header e Footer) */}
            <Route
              path="/perfil-cliente"
              element={
                <ProtectedRoute>
                  <PerfilDonoCarga />
                </ProtectedRoute>
              }
            />
            <Route
              path="/perfil-motorista"
              element={
                <ProtectedRoute>
                  <PerfilMotorista />
                </ProtectedRoute>
              }
            />

            {/* Páginas com HEADER + FOOTER (todas as páginas principais e autenticação) */}
            <Route path="/" element={<LayoutWithHeaderAndFooter><Home /></LayoutWithHeaderAndFooter>} />
            <Route path="/dono-da-carga" element={<LayoutWithHeaderAndFooter><DonoDaCarga /></LayoutWithHeaderAndFooter>} />
            <Route path="/motorista" element={<LayoutWithHeaderAndFooter><Motorista /></LayoutWithHeaderAndFooter>} />
            <Route path="/cidades" element={<LayoutWithHeaderAndFooter><Cidades /></LayoutWithHeaderAndFooter>} />
            <Route path="/carreiras" element={<LayoutWithHeaderAndFooter><Carreiras /></LayoutWithHeaderAndFooter>} />
            <Route path="/sobre" element={<LayoutWithHeaderAndFooter><SobreCargaFacil /></LayoutWithHeaderAndFooter>} />
            <Route path="/parceiros" element={<LayoutWithHeaderAndFooter><Parceiros /></LayoutWithHeaderAndFooter>} />
            <Route path="/mapa" element={<LayoutWithHeaderAndFooter><MapaPage /></LayoutWithHeaderAndFooter>} />

            {/* Rotas de autenticação (com HEADER + FOOTER) */}
            <Route
              path="/cliente/login"
              element={<LayoutWithHeaderAndFooter><LoginPage userType="client" /></LayoutWithHeaderAndFooter>}
            />
            <Route
              path="/motorista/login"
              element={<LayoutWithHeaderAndFooter><LoginPage userType="driver" /></LayoutWithHeaderAndFooter>}
            />
            <Route
              path="/cliente/cadastro"
              element={<LayoutWithHeaderAndFooter><RegisterPage userType="client" /></LayoutWithHeaderAndFooter>}
            />
            <Route
              path="/motorista/cadastro"
              element={<LayoutWithHeaderAndFooter><RegisterPage userType="driver" /></LayoutWithHeaderAndFooter>}
            />

            {/* Rotas legadas (redirecionamentos) */}
            <Route path="/login" element={<Navigate to="/cliente/login" replace />} />
            <Route path="/cadastro" element={<Navigate to="/cliente/cadastro" replace />} />
            <Route path="/register" element={<Navigate to="/cliente/cadastro" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};
export default App;